import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import React from 'react'

dayjs.extend(utc)
dayjs.extend(localizedFormat)

export const createDateTimeFormatter = () => new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' })

export const displayDateFormatter = (date: Date | string, showTime = false): string => {
  if (showTime) {
    return dayjs(date).format('MMMM D, YYYY, hA')
  }
  return dayjs.utc(date).format('LL')
}

export const createNumberFormatter = () => new Intl.NumberFormat('en-US')

export function kFormatter(num: number, lowercase?: boolean) {
  const letter = lowercase ? 'k' : 'K'
  return Math.abs(num) > 999
    ? Math.sign(num) * Math.floor(Math.abs(num) / 1000) + letter
    : Math.sign(num) * Math.abs(num)
}

export function formatNumberWithCommas(num: number) {
  return new Intl.NumberFormat('en-US', { style: 'decimal' }).format(num)
}

export function highlightText(text: string, highlightPhrase: string, className: string) {
  const parts = text.split(highlightPhrase)

  if (parts.length <= 1) return text

  return (
    <>
      {parts[0]}
      <mark className={className}>{highlightPhrase}</mark>
      {parts[1]}
    </>
  )
}
